import React, { Component } from 'react';
import Button from '../button/Button';

export default class NoBorderButton extends Component {
	render() {
		return (
			<Button bg="transparent" color="blue" noShadow {...this.props}>
				{this.props.children}
			</Button>
		);
	}
}
